/**
 * Configured display labels for the `scope` bag's well-known keys. Both the HTML and the React-PDF
 * `scope_fields` / legacy `project_details` renderers print these instead of the raw context key
 * (`job_site_count`), so a quote never shows an internal identifier. Any other key (an author
 * attribute such as `pour_type`) is humanised from its snake_case name.
 */
const SCOPE_FIELD_LABELS: Readonly<Record<string, string>> = {
  job_site_count: 'Job sites',
  phase_count: 'Phases',
  line_item_count: 'Line items'
};

export function scopeFieldLabel(key: string): string {
  const configured = SCOPE_FIELD_LABELS[key];
  if (configured) return configured;
  const words = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.toLowerCase());
  if (words.length === 0) return key;
  const [first, ...rest] = words;
  return [`${first?.charAt(0).toUpperCase() ?? ''}${first?.slice(1) ?? ''}`, ...rest].join(' ');
}

/** What a scope row prints for a value: empty / missing becomes an em dash, never the string "undefined". */
export function scopeFieldValue(value: unknown): string {
  if (value === undefined || value === null || value === '') return '\u2014';
  return String(value);
}
